import React, { useEffect, useState } from 'react';

import {
	Alert,
	Box,
	Button,
	CircularProgress,
	FormHelperText,
	Grid,
	Input,
	InputAdornment,
	Modal,
	Snackbar,
	TextField,
	Tooltip,
	tooltipClasses,
	Typography,
} from '@mui/material';

import { createTheme, ThemeProvider } from '@mui/material/styles';

import Popper from '@mui/material/Popper';

import IconButton from '@mui/material/IconButton';

import pencilICON from '../../../../../assets/logos/pencil_Icon_EDITCPT.png';
import delete_Icon from '../../../../../assets/logos/delete_Icon.png';

import CloseIcon from '@mui/icons-material/Close';

import CancelIcon from '@mui/icons-material/Cancel';

import WebLogo from '../../../../../assets/logos/websitelogo.svg';

import {
	Add,
	ArrowDropDown,
	ArrowDropUp,
	Delete,
	Minimize,
	Search,
} from '@mui/icons-material';
import {
	getDxCodes,
	getDxCodesId,
	getUserSettings,
	postUserSettings,
	updateUserSettings,
} from '../../../../services/api/apiManager';
import styled from 'styled-components';

const style = {
	position: 'absolute',
	top: '50%',
	left: '50%',
	transform: 'translate(-50%, -50%)',
	width: '55%',
	// height: '65vh',
	// overflow: 'auto',
	backgroundColor: 'white',
	border: ' 1px solid #00000026',
	borderRadius: '12px',
};

function CustomizeDX() {
	const defaultTheme = createTheme();
	const practiceID = localStorage.getItem('practice_id');
	const [openSnackbar, setOpenSnackbar] = useState({
		open: false,
		snackbarFor: '',
	});
	const [loading, setLoading] = useState(false);
	const [openModal, setOpenModal] = useState({ open: false, modalFor: '' });
	const [deleteModal, setdeleteModal] = useState({
		open: false,
		settingName: '',
	});
	const [editSettingNameModal, setEditSettingNameModal] = useState(false);
	const [wrapCodes, setWrapCodes] = useState(null);
	const [modalWrapCodes, setModalWrapCodes] = useState(null);
	const [modalLoading, setModalLoading] = useState(false);
	const [addListAnchorEl, setAddListAnchorEl] = useState(null);
	const [addSettingName, setAddSettingName] = useState(''); // I'm using this same state for adding name of custom-setting and also for updating name of  custom-setting as well

	const [selectedSettingId, setSelectedSettingId] = useState(0);
	const [userSettingsList, setUserSettingsList] = useState([]);
	const [nestedWrapCodes, setNestedWrapCodes] = useState([]);
	const [dxCodesAll, setDxCodesAll] = useState([]);
	const [dxWithID, setDxWithID] = useState([]);
	const [selectedDxCodes, setSelectedDxCodes] = useState([]);
	const [searchText, setSearchText] = useState('');
	const [searchFilter, setSearchFilter] = useState([]);

	const handleOpenAddList = (event) => {
		setAddListAnchorEl((prevaAnchorEl) =>
			prevaAnchorEl ? null : event.currentTarget
		);
	};
	const searchFilterHanlder = (event) => {
		setSearchText(event.target.value);
	};
	// Filter ICD
	const afterFilteration = searchFilter?.filter((items) => {
		return (
			items?.MinCode?.toLowerCase()?.includes(searchText.toLowerCase()) ||
			items?.MaxCode?.toLowerCase()?.includes(searchText.toLowerCase()) ||
			items?.Name?.toLowerCase()?.includes(searchText.toLowerCase())
		);
	});

	// function for aading new User Settings Name
	const addUserSetting = async (data) => {
		const resp = await postUserSettings(data);
		if (resp?.status === 201) {
			getUserSetting();
			setOpenSnackbar({ open: true, snackbarFor: 'newListAdded' });
			setAddSettingName('');
		} else {
			setOpenSnackbar({ open: true, snackbarFor: 'error' });
		}
	};
	const getUserSetting = async () => {
		setLoading(true);
		try {
			const resp = await getUserSettings();
			if (resp?.status === 200) {
				setUserSettingsList(
					resp?.data
						?.filter((items) => {
							return (
								items?.practice_id === parseInt(practiceID) &&
								(items?.Type === 'ICD' || items?.Type === 'icd')
							);
						})
						?.reverse()
				);
				setLoading(false);
			} else {
				setUserSettingsList([]);
			}
		} catch (error) {
			console.log(`ERROR-->`, error);
		}
	};
	const getDXCodesAll = async () => {
		const resp = await getDxCodes();
		if (resp?.status === 200) {
			setDxCodesAll(resp?.data);
			setSearchFilter(resp?.data);
		} else {
			setDxCodesAll([]);
		}
	};
	const getDXCodeWithID = async (id) => {
		setModalLoading(true);
		const resp = await getDxCodesId(id);
		if (resp?.status === 200) {
			setModalLoading(false);
			setDxWithID(resp?.data);
		} else {
			setDxWithID([]);
		}
	};

	const updateUserSetting = async (id, data) => {
		const resp = await updateUserSettings(id, data);
		if (resp?.status === 200) {
			setAddSettingName('');
			getUserSetting();
			setSelectedDxCodes([]);
			setWrapCodes(null);
			if (resp?.data?.Deleted) {
				setOpenSnackbar({ open: true, snackbarFor: 'listDeleted' });
			} else {
				setOpenSnackbar({ open: true, snackbarFor: 'listUpdated' });
			}
		} else {
			setOpenSnackbar({ open: true, snackbarFor: 'error' });
		}
	};
	const deleteNestedWrapCodes = async (id, data) => {
		const resp = await updateUserSettings(id, data);
		if (resp?.status === 200) {
			setOpenSnackbar({ open: true, snackbarFor: 'listDeleted' });
			//for getting all user setting details I can call getUserSetting()  function again here but there was loader in it and i dont want that loader
			const resp = await getUserSettings();
			setUserSettingsList(
				resp?.data
					?.filter((items) => {
						return (
							items?.practice_id === parseInt(practiceID) &&
							(items?.Type === 'ICD' || items?.Type === 'icd')
						);
					})
					?.reverse()
			);
			setSelectedDxCodes([]);
		} else {
			setOpenSnackbar({ open: true, snackbarFor: 'error' });
		}
	};

	// this function get all the selected codes of the a particular setting according to their id
	const wrapCodesAccordingtoSettingID = (id) => {
		userSettingsList
			?.map((items) => items?.setting_codes)
			?.forEach((wrap) => {
				if (
					wrap.filter(
						(findWrapCode) => findWrapCode?.setting_id == parseInt(id)
					).length > 0
				) {
					setNestedWrapCodes(
						wrap.filter(
							(findWrapCode) => findWrapCode?.setting_id == parseInt(id)
						)
					);
					setSelectedDxCodes(
						wrap.filter(
							(findWrapCode) => findWrapCode?.setting_id == parseInt(id)
						)
					);
				}
			});
	};
	useEffect(() => {
		getUserSetting();
		getDXCodesAll();
	}, []);
	return (
		<ThemeProvider theme={defaultTheme}>
			{loading ? ( // Display loading indicator if loading is true
				<div
					style={{
						width: '100%',
						height: '80vh',
						display: 'flex',
						justifyContent: 'center',
						alignItems: 'center',
					}}
				>
					<div className="logo-container">
						<img className="logo" src={WebLogo} alt="Website Logo" />
					</div>
				</div>
			) : (
				<>
					<Box
						width={'100%'}
						display={'flex'}
						justifyContent={'flex-end'}
						alignItems={'center'}
						height={'48px'}
					>
						<Button
							variant="contained"
							onClick={handleOpenAddList}
							aria-describedby={'add-list-popper'}
							sx={{
								width: '179px',
								height: {
									xs: '30px',
									sm: '30px',
									md: '46px',
									lg: '46px',
									xl: '46px',
								},
								bgcolor: '#00A2E8',
								borderRadius: '6px',
								color: '#FFFFFF',
								'&:hover': {
									background: '#00A2E8',
								},
								// marginTop: {
								// 	xs: '-1%',
								// 	sm: '-1%',
								// 	md: '1%',
								// 	lg: '1%',
								// 	xl: '1%',
								// },
								display: 'flex',
								gap: 1,
							}}
						>
							<Add />
							<span
								style={{
									fontSize: '18px',
									fontWeight: 400,
									fontFamily: 'Poppins',
								}}
							>
								Add List
							</span>
						</Button>

						<Popper
							sx={{ zIndex: 9 }}
							id={'add-list-popper'}
							open={addListAnchorEl}
							anchorEl={addListAnchorEl}
						>
							<Box
								sx={{
									borderRadius: '5px',
									boxShadow: '3px 3px 3px 3px #00000040',
									padding: '10px 15px',
									background: '#FFFFFF',
								}}
							>
								<Box
									sx={{
										display: 'flex',
										gap: '7px',
										alignItems: 'center',
										marginBottom: '7px',
									}}
								>
									<IconButton
										onClick={() => {
											setAddListAnchorEl(null);
										}}
										aria-describedby={'add-list-popper'}
										color="#ED2828"
									>
										<CloseIcon sx={{ color: '#ED2828' }} />
									</IconButton>
									<Typography
										variant="body2"
										sx={{
											fontFamily: 'Poppins',
											fontSize: '18px',
											fontWeight: 500,
											textAlign: 'center',
											color: 'black',
										}}
									>
										Add Name
									</Typography>
								</Box>
								<Input
									id="settingNameField"
									disableUnderline
									type="text"
									fullWidth
									value={addSettingName}
									onChange={(e) => setAddSettingName(e.target.value)}
									placeholder="Enter Name"
									sx={{
										borderRadius: '6px',
										border: '1px solid #383838',
										padding: '5px',
										marginBottom: '7px',
									}}
								/>
								{addSettingName === '' && (
									<FormHelperText
										sx={{ color: 'red' }}
									>{`Name should\'t be Empty`}</FormHelperText>
								)}
								<Box sx={{ display: 'flex', justifyContent: 'center' }}>
									<Button
										disabled={addSettingName === ''}
										onClick={() => {
											setAddListAnchorEl(null);
											setSelectedDxCodes([]);
											setOpenModal({ open: true, modalFor: 'addFirstTime' });
										}}
										sx={{
											width: '97px',
											height: '38px',
											bgcolor: `${addSettingName !== '' ? '#00A2E8' : 'grey'}`,
											borderRadius: '6px',
											border: '1px solid white',
											color: '#FFFFFF',
											'&:hover': {
												background: '#00A2E8',
											},
										}}
									>
										Proceed
									</Button>
								</Box>
							</Box>
						</Popper>
					</Box>
					<Box
						width={'100%'}
						height={'16px'}
						display={'flex'}
						justifyContent={'flex-start'}
						alignItems={'center'}
					>
						<Typography
							sx={{
								fontFamily: 'Poppins',
								fontWeight: 600,
								fontSize: '18px',
								color: '#075AD7',
							}}
						>
							{`All Custom ICD\'s List`}
						</Typography>
					</Box>
					<Grid
						container
						width={'100%'}
						height={'80%'}
						overflow={'auto'}
						// height={'238px'}
						// overflow={'auto'}
						borderRadius={'8px'}
						border={'1px solid #0000003D'}
						mt={1}
					>
						{userSettingsList.length === 0 && (
							<Box
								mt={1}
								width={'100%'}
								display={'flex'}
								justifyContent={'center'}
								color={'red'}
							>
								{' '}
								0 Record
							</Box>
						)}
						{userSettingsList?.map((items, index) => {
							return (
								<>
									<Grid
										item
										mt={index !== 0 && 0.5}
										key={index}
										xs={12}
										sm={12}
										md={12}
										lg={12}
										xl={12}
									>
										<Box
											width={'100%'}
											height={'37px'}
											bgcolor={'#C5DEF6'}
											borderBottom={'1px solid #4781D8'}
											borderRadius={'8px 0px 0px 0px'}
											display={'flex'}
											alignItems={'center'}
										>
											<Box
												width={'90%'}
												color={'#211E1E'}
												fontFamily={'Poppins'}
												fontSize={'15px'}
												fontWeight={600}
												height={'36px'}
												display={'flex'}
												justifyContent={'space-between'}
												alignItems={'center'}
											>
												<span style={{ width: '80%', marginLeft: '1%' }}>
													{items?.SettingName}
												</span>
												<Box
													width={'7%'}
													display={'flex'}
													justifyContent={'space-between'}
												>
													<Box
														width={'20%'}
														height={'35px'}
														bgcolor={'#C5DEF6'}
														display={'flex'}
														alignItems={'center'}
														justifyContent={'center'}
														sx={{ cursor: 'pointer' }}
													>
														{wrapCodes !== items?.id
															? items?.setting_codes?.length > 0 && (
																	<ArrowDropDown
																		onClick={() => {
																			setWrapCodes(
																				parseInt(
																					items?.setting_codes?.map(
																						(items) => items?.setting_id
																					)
																				)
																			);
																			wrapCodesAccordingtoSettingID(
																				items?.setting_codes?.map(
																					(items) => items?.setting_id
																				)
																			);
																		}}
																		sx={{ color: 'black' }}
																	/>
																)
															: items?.setting_codes?.length > 0 && (
																	<ArrowDropUp
																		onClick={() => setWrapCodes(null)}
																		sx={{ color: 'red' }}
																	/>
																)}
													</Box>
													<Tooltip title="Add More Codes">
														<Box
															width={'70%'}
															height={'35px'}
															bgcolor={'#3F9943'}
															display={'flex'}
															alignItems={'center'}
															justifyContent={'center'}
															sx={{ cursor: 'pointer' }}
															onClick={() => {
																wrapCodesAccordingtoSettingID(
																	items?.setting_codes?.map(
																		(items) => items?.setting_id
																	)
																);
																setOpenModal({
																	open: true,
																	modalFor: 'addMore',
																});
																setSelectedSettingId(items?.id);
																// setSelectedDxCodes(nestedWrapCodes);
															}}
														>
															<Add sx={{ color: 'whitesmoke' }} />
														</Box>
													</Tooltip>
												</Box>
											</Box>
											<Box
												onClick={() => {
													setSelectedSettingId(items?.id);
													setAddSettingName(items?.SettingName);
													setEditSettingNameModal(true);
												}}
												width={'5%'}
												height={'35px'}
												bgcolor={'#1D60C5'}
												display={'flex'}
												alignItems={'center'}
												justifyContent={'center'}
												sx={{ cursor: 'pointer' }}
											>
												<img
													src={pencilICON}
													alt="Pencil Icon for Edit"
													height={'15px'}
													width={'16px'}
												/>
											</Box>
											<Box
												onClick={() => {
													setSelectedSettingId(items?.id);
													setdeleteModal({
														open: true,
														settingName: items?.SettingName,
													});
												}}
												width={'5%'}
												height={'35px'}
												border={'1px solid #ED2828'}
												borderRadius={'0px 8px 0px 0px'}
												bgcolor={'#ED2828'}
												display={'flex'}
												alignItems={'center'}
												justifyContent={'center'}
												sx={{ cursor: 'pointer' }}
											>
												<img
													src={delete_Icon}
													alt="Delete ICon"
													height={'15px'}
													width={'16px'}
												/>
											</Box>
										</Box>
									</Grid>
									{/* Folded setting_codes that already added in particular Settings */}
									{wrapCodes === items?.id && (
										<>
											{/* I am using this logic just for the sake of avoiding rerendering if i dont use this approach Page Render again on each deletion that was very bad UX */}
											{nestedWrapCodes?.map((nestedItems, ind) => {
												return (
													<Grid
														key={ind}
														item
														xs={12}
														sm={12}
														md={12}
														lg={12}
														xl={12}
													>
														<Grid
															container
															justifyContent={'space-around'}
															borderBottom={'1px solid #00000087'}
															alignItems={'center'}
															sx={{
																height: {
																	xs: '',
																	sm: '',
																	md: '35px',
																	lg: '35px',
																	xl: '35px',
																},
															}}
															bgcolor={'#FFFFFF'}
														>
															<Grid item xs={12} sm={12} md={1} lg={1} xl={1}>
																<Typography
																	color={'#1D60C5'}
																	fontSize={'15px'}
																	fontFamily={'Poppins'}
																	fontWeight={600}
																>
																	{nestedItems?.Code}
																</Typography>
															</Grid>
															<Grid
																item
																xs={12}
																sm={12}
																md={9.5}
																lg={9.5}
																xl={9.5}
															>
																<CustomWidthTooltip
																	arrow
																	title={`(${nestedItems?.Code}) ${nestedItems?.CodeDescription}`}
																	placement="top-start"
																>
																	<Typography
																		color={'#2E476B'}
																		fontSize={'14px'}
																		fontFamily={'Poppins'}
																		fontWeight={400}
																	>
																		{nestedItems?.CodeDescription?.length > 130
																			? nestedItems?.CodeDescription.slice(
																					0,
																					130
																				) + '...'
																			: nestedItems?.CodeDescription}
																	</Typography>
																</CustomWidthTooltip>
															</Grid>
															<Grid
																item
																xs={12}
																sm={12}
																md={0.5}
																lg={0.5}
																xl={0.5}
																display={'flex'}
																alignItems={'center'}
																height={'33px'}
															>
																<Delete
																	onClick={() => {
																		const afterDeletion =
																			nestedWrapCodes?.filter(
																				(items) => items?.id !== nestedItems.id
																			);

																		setNestedWrapCodes(afterDeletion);

																		deleteNestedWrapCodes(items?.id, {
																			setting_codes: afterDeletion,
																		});
																	}}
																	sx={{ color: 'red', cursor: 'pointer' }}
																/>
															</Grid>
														</Grid>
													</Grid>
												);
											})}
										</>
									)}
								</>
							);
						})}
					</Grid>
				</>
			)}

			{/* I am using this same modal for creating the setting and also for updating the setting_codes when they added  */}
			<Modal
				open={openModal.open}
				onClose={() => {
					setOpenModal({ open: false, modalFor: '' });
					setAddSettingName('');
					setModalWrapCodes(null);
					setSelectedDxCodes([]);
				}} // Close Modal When any screen click.
				aria-labelledby="edit-modal-title"
				aria-describedby="edit-modal-description"
				sx={{
					'& .MuiModal-backdrop': {
						opacity: '0.75 !important',
					},
				}}
			>
				<Box sx={style}>
					<Grid
						position={'sticky'}
						top={0}
						left={0}
						item
						lg={12}
						xs={12}
						md={12}
						sm={12}
						xl={12}
						justifyContent="center"
					>
						<Box
							sx={{
								bgcolor: 'whitesmoke',
								width: '100%',
								height: '65px',
								display: 'flex',
								justifyContent: 'center',
								alignItems: 'center',
								borderBottom: '1px solid #00000070',
							}}
						>
							<Typography
								sx={{
									width: '88%',
									fontFamily: 'Poppins',
									fontSize: '25px',
									fontWeight: 500,
									textAlign: 'center',
								}}
							>
								Select ICDs
							</Typography>
							<IconButton
								onClick={() => {
									setOpenModal({ open: false, modalFor: '' });
									setAddSettingName('');
									setModalWrapCodes(null);
									setSelectedDxCodes([]);
								}}
							>
								<CancelIcon sx={{ fontSize: '30px' }} color="error" />
							</IconButton>
						</Box>
						<Box
							width={'100%'}
							height={'57px'}
							bgcolor={'whitesmoke'}
							border={'1px solid #00000012'}
							display={'flex'}
							alignItems={'center'}
							justifyContent={'center'}
						>
							<TextField
								variant="standard"
								type="text"
								id="searchICD"
								value={searchText}
								onChange={(event) => {
									searchFilterHanlder(event);
								}}
								sx={{
									width: '80%',
									height: '39px',
									borderRadius: '42px',
									border: '1px solid #294774',
									bgcolor: '#FFFFFF',
									'& .MuiInput-root': {
										fontSize: '20px',
										color: 'black',
										fontFamily: 'Poppins',
										fontWeight: 400,
										// Bottom border
										'&:before': {
											borderColor: 'none',
											borderWidth: '0px',
										},
										'&:after': {
											borderColor: 'none',
											borderWidth: '0px',
										},
										':hover': {
											'&:before': {
												borderColor: 'none',
												borderWidth: '0px',
											},
										},
									},
								}}
								placeholder="Search..."
								InputProps={{
									startAdornment: (
										<InputAdornment sx={{ marginLeft: '1%' }} position="start">
											<Search />
										</InputAdornment>
									),
								}}
							/>
						</Box>
					</Grid>
					<Grid
						item
						xs={12}
						sm={12}
						md={12}
						lg={12}
						xl={12}
						height={'50vh'}
						overflow={'auto'}
					>
						{/*(inside of MODAL) code For add More Codes - that we wants to add in our particular setting */}
						{afterFilteration.length === 0 && (
							<Box
								width={'100%'}
								display={'flex'}
								justifyContent={'center'}
								color={'red'}
								mt={1}
							>
								No Match Found
							</Box>
						)}
						{afterFilteration?.map((items, index) => {
							return (
								<>
									<Grid
										key={index}
										container
										justifyContent={'space-evenly'}
										borderBottom={'1px solid #00000087'}
										alignItems={'center'}
										height={'40px'}
										bgcolor={'#FFFFFF'}
									>
										<Grid item xs={2} sm={2} md={2} lg={2} xl={2}>
											<Typography
												color={'#1D60C5'}
												fontSize={'15px'}
												fontFamily={'Poppins'}
												fontWeight={600}
											>
												{items?.MinCode} - {items?.MaxCode}
											</Typography>
										</Grid>
										<Grid item xs={8.2} sm={8.2} md={8.2} lg={8.2} xl={8.2}>
											<Typography
												color={'#2E476B'}
												fontSize={'14px'}
												fontFamily={'Poppins'}
												fontWeight={400}
											>
												{items?.Name}
											</Typography>
										</Grid>
										<Grid
											item
											xs={0.5}
											sm={0.5}
											md={0.5}
											lg={0.5}
											xl={0.5}
											display={'flex'}
											alignItems={'center'}
										>
											{modalWrapCodes === null ||
											modalWrapCodes !== items?.id ? (
												<Add
													onClick={() => {
														setModalLoading(true);
														getDXCodeWithID(items?.id);
														setModalWrapCodes(items?.id);
													}}
													sx={{
														color: '#1D60C5',
														cursor: 'pointer',
														fontSize: '25px',
													}}
												/>
											) : (
												<Minimize
													onClick={() => {
														setModalWrapCodes(null);
													}}
													sx={{
														color: '#1D60C5',
														cursor: 'pointer',
														fontSize: '25px',
														marginTop: '-12px',
													}}
												/>
											)}
										</Grid>
									</Grid>
									{modalWrapCodes == items?.id && modalLoading && (
										<Box
											width={'100%'}
											height={'10vh'}
											display={'flex'}
											justifyContent={'center'}
											alignItems={'center'}
										>
											{' '}
											<CircularProgress />
										</Box>
									)}
									{modalWrapCodes == items?.id &&
										dxWithID?.map((nestedItems, index) => {
											{
												/* (inside of MODAL) show more codes Box is here on the Add icon */
											}
											return (
												!modalLoading && (
													<Grid
														key={index}
														container
														justifyContent={'space-evenly'}
														borderBottom={'1px solid #00000087'}
														alignItems={'center'}
														height={'35px'}
														bgcolor={'#FFFFFF'}
													>
														<Grid
															item
															xs={2}
															sm={2}
															md={2}
															lg={2}
															xl={2}
															display={'flex'}
															height={'33px'}
															alignItems={'center'}
															gap={0.4}
														>
															<input
																checked={
																	selectedDxCodes.filter(
																		(items) => items.Code == nestedItems.Code
																	)[0]?.Code !== undefined &&
																	selectedDxCodes.filter(
																		(items) => items.Code == nestedItems.Code
																	)[0]?.Code
																}
																value={nestedItems?.Code}
																onChange={(event) => {
																	if (event.target.checked) {
																		setSelectedDxCodes((prev) => [
																			...prev,
																			{
																				setting_id: selectedSettingId,
																				CodeType: 'ICD',
																				Code: event.target.value,
																				CodeDescription:
																					nestedItems?.Description,
																			},
																		]);
																	} else {
																		const removeCodes = selectedDxCodes.filter(
																			(items) =>
																				items?.Code !== event.target.value
																		);
																		setSelectedDxCodes(removeCodes);
																	}
																}}
																type="checkbox"
																id={nestedItems?.Code}
																style={{ cursor: 'pointer', width: '25px' }}
															></input>
															<label
																htmlFor={nestedItems?.Code}
																style={{
																	color: '#1D60C5',
																	fontSize: '15px',
																	fontWeight: 600,
																	fontFamily: 'Poppins',
																}}
															>
																{nestedItems?.Code}
															</label>
														</Grid>
														<CustomWidthTooltip
															arrow
															title={`(${nestedItems?.Code}) ${nestedItems?.Description}`}
															placement="top-start"
														>
															<Grid item xs={9} sm={9} md={9} lg={9} xl={9}>
																<Typography
																	color={'#2E476B'}
																	fontSize={'14px'}
																	fontFamily={'Poppins'}
																	fontWeight={400}
																>
																	{(nestedItems?.Description).slice(0, 55)}...
																</Typography>
															</Grid>
														</CustomWidthTooltip>
													</Grid>
												)
											);
										})}
								</>
							);
						})}
					</Grid>

					<Box
						position={'fixed'}
						bgcolor={'whitesmoke'}
						bottom={0}
						left={0}
						mt={1}
						width={'100%'}
						height={'70px'}
						display={'flex'}
						alignItems={'center'}
						justifyContent={'center'}
						gap={2}
					>
						<Button
							onClick={() => {
								setOpenModal({ open: false, modalFor: '' });
								setModalWrapCodes(null);
								setSelectedDxCodes([]);
								setAddSettingName('');
							}}
							style={{
								backgroundColor: '#ED2828',
								width: '151px',
								height: '52px',
								borderRadius: '7px',
								color: '#FFFFFF',
								fontSize: '20px',
							}}
						>
							Cancel
						</Button>
						{openModal.modalFor === 'addFirstTime' ? (
							<Button
								style={{
									backgroundColor: '#00A2E8',
									width: '240px',
									height: '52px',
									borderRadius: '7px',
									color: '#FFFFFF',
									fontSize: '20px',
								}}
								onClick={() => {
									addUserSetting({
										practice_id: practiceID,
										Type: 'ICD',
										SettingName: addSettingName,
										setting_codes: selectedDxCodes,
									});
									setAddSettingName('');
									setOpenModal({ open: false, modalFor: '' });
									setSelectedDxCodes([]);
								}}
							>
								Add New
							</Button>
						) : (
							<Button
								style={{
									backgroundColor: '#00A2E8',
									width: '240px',
									height: '52px',
									borderRadius: '7px',
									color: '#FFFFFF',
									fontSize: '20px',
								}}
								onClick={() => {
									updateUserSetting(selectedSettingId, {
										setting_codes: selectedDxCodes,
									});
									setOpenModal({ open: false, modalFor: '' });
									setSelectedDxCodes([]);
									setAddSettingName('');
								}}
							>
								Add More
							</Button>
						)}
					</Box>
				</Box>
			</Modal>

			{/* delete modal is here */}
			<Modal
				open={deleteModal?.open}
				onClose={() => {
					setdeleteModal({ open: false });
				}} // Close Modal When any screen click.
				aria-labelledby="edit-modal-title"
				aria-describedby="edit-modal-description"
				sx={{
					'& .MuiModal-backdrop': {
						opacity: '0.75 !important',
					},
				}}
			>
				<Box sx={{ ...style, width: '30%' }}>
					<Grid
						item
						lg={12}
						xs={12}
						md={12}
						sm={12}
						xl={12}
						justifyContent="center"
					>
						<Box
							sx={{
								width: '100%',
								display: 'flex',
								justifyContent: 'center',
								alignItems: 'center',
								borderBottom: '1px solid #00000070',
							}}
						>
							<Typography
								sx={{
									width: '90%',
									fontFamily: 'Poppins',
									// fontSize: '25px',
									fontSize: {
										xs: '10px',
										sm: '10px',
										md: '25px',
										lg: '25px',
										xl: '25px',
									},
									fontWeight: 500,
									textAlign: 'center',
								}}
							>
								Delete Custom List
							</Typography>
							<IconButton
								sx={{ width: '5%' }}
								onClick={() => {
									setdeleteModal({ open: false });
								}}
							>
								<CancelIcon
									sx={{
										fontSize: {
											xs: '10px',
											sm: '10px',
											md: '30px',
											lg: '30px',
											xl: '30px',
										},
									}}
									color="error"
								/>
							</IconButton>
						</Box>
					</Grid>
					<Box width={'100%'}>
						<Typography
							textAlign="center"
							sx={{
								fontFamily: 'Poppins',
								fontWeight: '500',
								fontSize: {
									xs: '10px',
									sm: '10px',
									md: '16px',
									lg: '16px',
									xl: '16px',
								},
							}}
						>
							{' '}
							Are you sure you want to delete ?
						</Typography>
						<Typography
							textAlign="center"
							sx={{
								fontFamily: 'Poppins',
								fontWeight: '600',
								fontSize: {
									xs: '10px',
									sm: '10px',
									md: '18px',
									lg: '18px',
									xl: '18px',
								},
								color: '#075AD7',
							}}
						>
							{deleteModal?.settingName}
						</Typography>
					</Box>
					<Box
						mt={1}
						width={'100%'}
						display={'flex'}
						sx={{
							flexDirection: {
								xs: 'column',
								sm: 'column',
								md: 'row',
								lg: 'row',
								xl: 'row',
							},
						}}
						alignItems={'center'}
						justifyContent={'center'}
						gap={2}
					>
						<Button
							onClick={() => {
								setdeleteModal({ open: false });
							}}
							style={{
								backgroundColor: '#ED2828',
								width: '80px',
								height: '30px',
								borderRadius: '7px',
								color: '#FFFFFF',
								fontSize: '14px',
							}}
						>
							Cancel
						</Button>
						<Button
							style={{
								backgroundColor: '#00A2E8',
								width: '80px',
								height: '30px',
								borderRadius: '7px',
								color: '#FFFFFF',
								fontSize: '14px',
							}}
							onClick={() => {
								updateUserSetting(selectedSettingId, {
									Deleted: true,
								});
								setdeleteModal({ open: false });
							}}
						>
							Delete
						</Button>
					</Box>
				</Box>
			</Modal>
			{/* edit setting name modal is here */}
			<Modal
				open={editSettingNameModal}
				onClose={() => {
					setEditSettingNameModal(false);
					setAddSettingName('');
				}} // Close Modal When any screen click.
				aria-labelledby="edit-modal-title"
				aria-describedby="edit-modal-description"
				sx={{
					'& .MuiModal-backdrop': {
						opacity: '0.75 !important',
					},
				}}
			>
				<Box sx={{ ...style, width: '30%' }}>
					<Grid
						item
						lg={12}
						xs={12}
						md={12}
						sm={12}
						xl={12}
						justifyContent="center"
					>
						<Box
							sx={{
								width: '100%',
								display: 'flex',
								justifyContent: 'center',
								alignItems: 'center',
								borderBottom: '1px solid #00000070',
							}}
						>
							<Typography
								sx={{
									width: '88%',
									fontFamily: 'Poppins',
									fontSize: {
										xs: '10px',
										sm: '10px',
										md: '25px',
										lg: '25px',
										xl: '25px',
									},
									fontWeight: 500,
									textAlign: 'center',
								}}
							>
								Rename Custom List Name
							</Typography>
							<IconButton
								onClick={() => {
									setEditSettingNameModal(false);
									setAddSettingName('');
								}}
							>
								<CancelIcon
									sx={{
										fontSize: {
											xs: '10px',
											sm: '10px',
											md: '30px',
											lg: '30px',
											xl: '30px',
										},
									}}
									color="error"
								/>
							</IconButton>
						</Box>
					</Grid>
					<Box width={'100%'}>
						<Input
							id="settingNameField2"
							disableUnderline
							type="text"
							fullWidth
							value={addSettingName}
							onChange={(e) => setAddSettingName(e.target.value)}
							placeholder="Enter Name"
							sx={{
								borderRadius: '6px',
								border: '1px solid #383838',
								padding: {
									xs: '0px',
									sm: '0px',
									md: '5px',
									lg: '5px',
									xl: '5px',
								},
								marginBottom: '7px',
							}}
						/>
						{addSettingName === '' && (
							<FormHelperText
								sx={{ color: 'red' }}
							>{`*Name should\'t be Empty`}</FormHelperText>
						)}
					</Box>
					<Box
						mt={1}
						width={'100%'}
						display={'flex'}
						sx={{
							flexDirection: {
								xs: 'column',
								sm: 'column',
								md: 'row',
								lg: 'row',
								xl: 'row',
							},
						}}
						alignItems={'center'}
						justifyContent={'center'}
						gap={2}
					>
						<Button
							onClick={() => {
								setEditSettingNameModal(false);
								setAddSettingName('');
							}}
							style={{
								backgroundColor: '#ED2828',
								width: '80px',
								height: '30px',
								borderRadius: '7px',
								color: '#FFFFFF',
								fontSize: '14px',
							}}
						>
							Cancel
						</Button>
						<Button
							disabled={addSettingName === '' ? true : false}
							style={{
								backgroundColor: `${addSettingName === '' ? 'grey' : '#00A2E8'}`,
								width: '80px',
								height: '30px',
								borderRadius: '7px',
								color: '#FFFFFF',
								fontSize: '14px',
							}}
							onClick={() => {
								updateUserSetting(selectedSettingId, {
									SettingName: addSettingName,
								});
								setEditSettingNameModal(false);
							}}
						>
							Rename
						</Button>
					</Box>
				</Box>
			</Modal>

			{/* snack bar for Patient added successfully */}
			<Snackbar
				open={openSnackbar.open}
				autoHideDuration={2000} // Adjust the duration as needed
				onClose={() => setOpenSnackbar({ open: false })}
				anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
			>
				<Alert
					onClose={() => setOpenSnackbar({ open: false, snackbarFor: '' })}
					severity={openSnackbar.snackbarFor === 'error' ? 'error' : 'success'}
					sx={{
						backgroundColor: '#3EAE4D',
						fontSize: '15px',
						padding: '15px',
						color: 'white',
						'& .MuiAlert-icon': {
							color: 'white', // Change icon color to white
						},
					}}
				>
					{openSnackbar.snackbarFor === 'listUpdated'
						? ` Updated Successfully!`
						: openSnackbar.snackbarFor === 'newListAdded'
							? 'Custom-ICD List Added Successfully!'
							: openSnackbar.snackbarFor === 'listDeleted'
								? 'Deleted SuccessFully'
								: openSnackbar.snackbarFor === 'error'
									? 'ERROR!'
									: ''}
				</Alert>
			</Snackbar>
		</ThemeProvider>
	);
}

export default CustomizeDX;
// our custom tooltip styling code is here
const CustomWidthTooltip = styled(({ className, ...props }) => (
	<Tooltip {...props} classes={{ popper: className }} />
))({
	[`& .${tooltipClasses.tooltip}`]: {
		maxWidth: 500,
		backgroundColor: 'gray',
		fontSize: '12px',
	},
});
